import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import ArticleList from './components/ArticleList';

export default function ArticlesPage() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <ArticleList />
      <Footer />
    </>
  );
}